import FastMarquee from "react-fast-marquee";
import { useLang } from "@/i18n";

const photos = [
  "/assets/farm/community-group.jpeg",
  "/assets/farm/process-press.jpeg",
  "/assets/farm/moment-winnowing.jpeg",
  "/assets/farm/community-filtering.jpeg",
  "/assets/farm/moment-copra.jpeg",
  "/assets/farm/bottling-station.jpeg",
  "/assets/farm/moment-weighing.jpeg",
  "/assets/farm/hero-seeds-pour.jpeg",
  "/assets/farm/training-session.jpeg",
  "/assets/farm/community-wide.jpeg",
  "/assets/farm/inauguration-coconut.jpeg",
  "/assets/farm/inauguration-ribbon.jpeg",
];

export default function PhotoStrip() {
  const { t } = useLang();
  return (
    <section className="border-y border-ink/10 bg-cream py-12" data-testid="photo-strip">
      <FastMarquee speed={18} gradient={false}>
        {photos.map((src, i) => (
          <div key={src} className={`mx-3 overflow-hidden border border-ink/10 ${i % 3 === 1 ? "arch-frame" : ""}`}>
            <img
              src={src}
              alt="Real moments from the Sira Shakti oil processing unit"
              className="h-52 w-40 object-cover sm:h-64 sm:w-52"
              loading="lazy"
            />
          </div>
        ))}
      </FastMarquee>
      <p className="mt-8 text-center text-xs uppercase tracking-[0.2em] text-moss">{t("extras.photoStripCaption")}</p>
    </section>
  );
}
